<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="charge-selector-dialog"
    :visible.sync="innerVisible"
    :title="title"
    width="870px"
    :close-on-click-modal="false"
  >
    <el-scrollbar style="height:60vh;width:auto;" :native="true">
      <!--  todo: config-module  -->
      <search-item
        ref="searchItem"
        :show-more-scheme="true"
        :show-simple="true"
        :expand-adv="true"
        sim-url=""
        adv-url=""
        :search-item-code="$t('Clearing.Invoice')"
        search-item-mode="querydata"
        config-module="800"
      >
        <template v-if="paramsFinal.mode === 1" v-slot:searchAreaHeader>
          <div class="app-main-inner-row" style="background: #eaeaea">
            <el-form ref="basicForm" :inline="true" label-position="left" label-width="60px">
              <el-form-item :label="$t('Clearing.QueryMethod')" class="dense-radio-group">
                <el-radio-group v-model="searchConditions.queryMode" no="1">
                  <el-radio :label="1">{{ $t('Clearing.ByFee') }}</el-radio>
                  <el-radio :label="2">{{ $t('Clearing.ByBusiness') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label-width="0px">
                <el-checkbox no="2">{{ $t('Clearing.IncludeReceivables') }}</el-checkbox>
              </el-form-item>
              <el-form-item label-width="0">
                <span style="color: darkred;">{{ $t('Clearing.NoteFilteredOutFullyBusiness') }}</span>
              </el-form-item>
            </el-form>
          </div>
        </template>
      </search-item>
      <div class="app-main-inner-row row-grid" style="min-height: 180px;">
        <cargo-ag-grid
          v-if="searchConditions.queryMode===1"
          key="190802"
          config-module="190802"
          :grid-params.sync="chargeGrid.gridParams"
          :grid-options="chargeGrid.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="chargeGrid.rowData"
        />
        <cargo-ag-grid
          v-if="searchConditions.queryMode===2"
          key="190803"
          config-module="190803"
          :grid-params.sync="jobGrid.gridParams"
          :grid-options="jobGrid.gridOptions"
          :column-defs="jobGrid.columnDefs"
          :row-data="jobGrid.rowData"
        />
      </div>
      <div class="app-main-inner-row row-pagination-right" style="padding: 0 10px;">
        <cargo-pagination
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="fetchData"
        />
        <div class="total-detail-popover">
          <span><b>USD:</b></span>
          <span><u>666666</u></span>
          <span><b>RMB:</b></span>
          <span><u>666666</u></span>
          <span><b>{{ $t('Clearing.EquivalentToRMB') }}</b></span>
          <span><u>666666</u></span>
        </div>
      </div>
    </el-scrollbar>

    <div slot="footer">
      <el-button v-if="paramsFinal.mode === 0" no="3" type="primary" @click="confirm">{{ Message.Confirm }}</el-button>
      <el-button v-if="paramsFinal.mode === 1" no="4" type="primary" @click="toNext">{{ $t('Clearing.NextStep') }}</el-button>
      <el-button no="5" @click="innerVisible = false">{{ $t('Clearing.Cancel') }}</el-button>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </el-dialog>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'

export default {
  name: 'ChargeSelectorDialog',
  components: { searchItem, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    /**
     * params.mode: 弹窗模式[default:0]
     *    0-选择费用
     *    1-创建付款申请-选择费用
     */
    params: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      documentManage: new DocumentManage(),
      searchConditions: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        queryMode: 1
      },
      chargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Clearing.BusinessNumber'),
            field: 'job_jobNo',
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              return `<a href="/" style="color:#0052cc;">${params.value}</a>
                <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          },
          {
            headerName: this.$t('Clearing.WarehouseEntryNumber'),
            field: 'job_warehouseNo'
          },
          {
            headerName: this.$t('Clearing.BookingNumber'),
            field: 'job_bookingNo'
          },
          {
            headerName: this.$t('Clearing.CutOffDate'),
            field: 'job_fileCutoff'
          },
          {
            headerName: this.$t('Clearing.ProjectNumber'),
            field: 'job_PONO'
          },
          {
            headerName: 'SONO',
            field: 'job_soNo'
          },
          {
            headerName: this.$t('Clearing.ContainerNumber'),
            field: 'job_containerNo'
          },
          {
            headerName: this.$t('Clearing.OverseasCustomerService'),
            field: 'job_overseaOp'
          },
          {
            headerName: this.$t('Clearing.PaymentApplicationNumber'),
            field: 'billPayment_billPaymentNo'
          },
          {
            headerName: 'ETA',
            field: 'job_ETA'
          },
          {
            headerName: 'ETD',
            field: 'job_ETD'
          },
          {
            headerName: this.$t('Clearing.BillNumber'),
            field: 'billing_billingNo'
          },
          {
            headerName: this.$t('Clearing.SettlementObject'),
            field: 'charge_accountId'
          },
          {
            headerName: this.$t('Clearing.CargoType'),
            field: 'job_cargoSource'
          },
          {
            headerName: this.$t('Clearing.MasterBillNumber'),
            field: 'job_mbl'
          },
          {
            headerName: this.$t('Clearing.HouseWaybillNumber'),
            field: 'job_import_hbl'
          },
          {
            headerName: this.$t('Clearing.Client'),
            field: 'job_customerId'
          },
          {
            headerName: this.$t('Clearing.BusinessType'),
            field: 'job_lob'
          },
          {
            headerName: this.$t('Clearing.BusinessDate'),
            field: 'job_businessDate'
          },
          {
            headerName: this.$t('Clearing.VesselVoyage'),
            field: 'job_vesselFlight'
          },
          {
            headerName: this.$t('Clearing.DeparturePort'),
            field: 'job_loadingPortCode'
          },
          {
            headerName: this.$t('Clearing.DestinationPort'),
            field: 'job_destinationPortCode'
          },
          {
            headerName: this.$t('Clearing.StartingStation'),
            field: 'job_departureStation'
          },
          {
            headerName: this.$t('Clearing.TerminusStation'),
            field: 'job_destinationStation'
          },
          {
            headerName: this.$t('Clearing.TransitStation'),
            field: 'job_transitStation'
          },
          {
            headerName: this.$t('Clearing.DestinationPortAgent'),
            field: 'job_destinationAgent'
          },
          {
            headerName: this.$t('Clearing.Sales'),
            field: 'job_sales'
          },
          {
            headerName: this.$t('Clearing.Operation'),
            field: 'job_op'
          },
          {
            headerName: this.$t('Clearing.CustomerService'),
            field: 'job_csr'
          },
          {
            headerName: this.$t('Clearing.Documentation'),
            field: 'job_dc'
          },
          {
            headerName: this.$t('Clearing.BusinessReferenceNumber'),
            field: 'job_customerRefNo'
          },
          {
            headerName: this.$t('Clearing.CustomBusinessType'),
            field: 'job_customJobType'
          },
          {
            headerName: this.$t('Clearing.Accrued'),
            field: 'job_provisioned'
          },
          {
            headerName: this.$t('Clearing.FinancialDate'),
            field: 'charge_accountingDate'
          },
          {
            headerName: this.$t('Clearing.DomesticForeign'),
            field: 'charge_oversea'
          },
          {
            headerName: this.$t('Clearing.IncomeAndExpensesType'),
            field: 'charge_receivable'
          },
          {
            headerName: this.$t('Clearing.ExpenseStatus'),
            field: 'charge_chargeState'
          },
          {
            headerName: this.$t('Clearing.Auditor'),
            field: 'charge_auditor'
          },
          {
            headerName: this.$t('Clearing.ConfirmationStatus'),
            field: 'charge_confirmState'
          },
          {
            headerName: this.$t('Clearing.CostName'),
            field: 'charge_chargeItemId'
          },
          {
            headerName: this.$t('Clearing.Unit'),
            field: 'charge_measure'
          },
          {
            headerName: this.$t('Clearing.Currency'),
            field: 'charge_currency'
          },
          {
            headerName: this.$t('Clearing.Quantity'),
            field: 'charge_quantity'
          },
          {
            headerName: this.$t('Clearing.UnitPrice'),
            field: 'charge_unitRate'
          },
          {
            headerName: this.$t('Clearing.TaxIncludedPrice'),
            field: 'charge_amount'
          },
          {
            headerName: this.$t('Clearing.PriceExclusiveOfTax'),
            field: 'charge_excludingTaxAmount'
          },
          {
            headerName: this.$t('Clearing.TaxAmount'),
            field: 'charge_taxAmount'
          },
          {
            headerName: this.$t('Clearing.TaxRate'),
            field: 'charge_taxRate'
          },
          {
            headerName: this.$t('Clearing.WrittenOffAmount'),
            field: 'charge_verifiedAmount'
          },
          {
            headerName: this.$t('Clearing.UnwrittenAmount'),
            field: 'charge_unverifiedAmount'
          },
          {
            headerName: this.$t('Clearing.ContactPerson'),
            field: 'charge_contactPerson'
          },
          {
            headerName: this.$t('Clearing.Creator'),
            field: 'charge_createdBy'
          },
          {
            headerName: this.$t('Clearing.CreationDate'),
            field: 'charge_dateCreated'
          },
          {
            headerName: this.$t('Clearing.Remarks'),
            field: 'charge_remarks'
          },
          {
            headerName: this.$t('Clearing.CorrelationNumber'),
            field: 'job_relatedJob'
          },
          {
            headerName: this.$t('Clearing.DelegationCorrelationNumber'),
            field: 'job_trustFromJob'
          },
          {
            headerName: this.$t('Clearing.Carrier'),
            field: 'job_carrierId'
          },
          {
            headerName: this.$t('Clearing.ConfirmationDate'),
            field: 'charge_confirmDate'
          },
          {
            headerName: this.$t('Clearing.ExpenseConfirmer'),
            field: 'charge_confirmUser'
          },
          {
            headerName: this.$t('Clearing.RouteResponsiblePerson'),
            field: 'job_planner'
          },
          {
            headerName: this.$t('Clearing.BillingDate'),
            field: 'invoice_invoiceDate'
          },
          {
            headerName: this.$t('Clearing.InvoiceNumber'),
            field: 'charge_invoiceNo'
          },
          {
            headerName: this.$t('Clearing.BillingHeader'),
            field: 'invoice_title'
          },
          {
            headerName: this.$t('Clearing.NeedForInvoicing'),
            field: 'charge_needInvoice'
          },
          {
            headerName: this.$t('Clearing.ConfirmationRemark'),
            field: 'charge_confirmRemarks'
          },
          {
            headerName: this.$t('Clearing.ReconciliationDate'),
            field: 'charge_clearingDate'
          },
          {
            headerName: this.$t('Clearing.BusinessStatus'),
            field: 'job_jobState'
          },
          {
            headerName: this.$t('Clearing.CustomField1'),
            field: 'job_userDefinedField1'
          },
          {
            headerName: this.$t('Clearing.CustomField2'),
            field: 'job_userDefinedField2'
          },
          {
            headerName: this.$t('Clearing.CustomField3'),
            field: 'job_userDefinedField3'
          },
          {
            headerName: this.$t('Clearing.ReceiptpaymentDate'),
            field: 'charge_payReceiveDate'
          },
          {
            headerName: this.$t('Clearing.SalesDepartment'),
            field: 'job.salesDepartment'
          }
        ],
        rowData: [{ job_jobNo: '12345' }]
      },
      jobGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Clearing.BusinessNumber'),
            field: 'job_jobNo',
            cellRenderer: params => {
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              return `<a href="/" style="color:#0052cc;">${params.value}</a>
                <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          },
          {
            headerName: this.$t('Clearing.MasterBillNumber'),
            field: 'job_mbl'
          },
          {
            headerName: this.$t('Clearing.Client'),
            field: 'job_customerId'
          },
          {
            headerName: this.$t('Clearing.SettlementObject'),
            field: 'charge_accountId'
          },
          {
            headerName: this.$t('Clearing.Carrier'),
            field: 'job_carrierId'
          },
          {
            headerName: 'SONO',
            field: 'job_soNo'
          },
          {
            headerName: this.$t('Clearing.OverseasCustomerService'),
            field: 'job_overseaOp'
          },
          {
            headerName: this.$t('Clearing.BusinessType'),
            field: 'job_lob'
          },
          {
            headerName: this.$t('Clearing.BusinessDate'),
            field: 'job_businessDate'
          },
          {
            headerName: this.$t('Clearing.VesselVoyage'),
            field: 'job_vessel'
          },
          {
            headerName: this.$t('Clearing.DeparturePort'),
            field: 'job_loadingPortCode'
          },
          {
            headerName: this.$t('Clearing.DestinationPort'),
            field: 'job_destinationPortCode'
          },
          {
            headerName: this.$t('Clearing.Operation'),
            field: 'job_op'
          },
          {
            headerName: this.$t('Clearing.Sales'),
            field: 'job_sales'
          },
          {
            headerName: this.$t('Clearing.Accrued'),
            field: 'job_provisioned'
          },
          {
            headerName: this.$t('Clearing.Currency'),
            field: 'charge_currency'
          },
          {
            headerName: this.$t('Clearing.TaxIncludedPrice'),
            field: 'charge_amount'
          },
          {
            headerName: this.$t('Clearing.CustomField1'),
            field: 'job_userDefinedField1'
          },
          {
            headerName: this.$t('Clearing.CustomField2'),
            field: 'job_userDefinedField2'
          },
          {
            headerName: this.$t('Clearing.CustomField3'),
            field: 'job_userDefinedField3'
          }
        ],
        rowData: [{ job_jobNo: '12345' }]
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      }
    }
  },
  computed: {
    title() {
      return this.paramsFinal.mode === 0 ? this.$t('CargoMsg.Cargo_ChooseFee') : this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees')
    },
    paramsFinal() {
      const defaultParams = {
        mode: 0
      }
      return Object.assign(defaultParams, this.params)
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
  },
  methods: {
    fetchData() {
      // todo 加载列表数据
      const rowData = [
        { job_jobNo: '12345' }
      ]
      switch (this.searchConditions.makeInvoiceMethod) {
        case 1: this.chargeGrid.rowData = rowData
          break
        case 2: this.jobGrid.rowData = rowData
          break
      }
    },
    confirm() {
      const self = this
      getGridSelectedIds(this.getGridOptions()).then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.$emit('selected', getGridSelected(this.getGridOptions())[0])
          this.innerVisible = false
        }
      })
    },
    toNext() {
      const self = this
      getGridSelectedIds(this.getGridOptions()).then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          this.$emit('next', getGridSelected(this.getGridOptions())[0])
        }
      })
    },
    // 【业务编号】列单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // todo: 需要根据value装配this.templateSelectorDialog中相关内容
      const self = this
      if (!value) {
        self.$message.warning(`没有找到${value}对应的打印模板`)
      } else {
        this.templateSelectorDialog.data.JOB_UUID = [value]
        this.templateSelectorDialog.visible = true
      }
    },
    // 获取cargo-ag-grid表格组件的gridOptions
    getGridOptions() {
      let gridOptions
      switch (this.searchConditions.queryMode) {
        case 1: gridOptions = this.chargeGrid.gridOptions
          break
        case 2: gridOptions = this.jobGrid.gridOptions
          break
      }
      return gridOptions
    }
  }
}
</script>

<style lang="scss">
.charge-selector-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .dense-radio-group {
    .el-form-item {
      margin-bottom: 0 !important;
      .el-form-item__content {
        vertical-align: middle;
      }
    }
    .el-radio {
      margin-right: 8px !important;
      .el-radio__label {
        padding-left: 5px!important;
      }
    }
  }
  .total-detail-popover {
    display: flex;
    align-items: center;
    justify-content: center;
    >span {
      padding-right: 6px;
    }
  }
}
</style>
